import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Modal, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import ExpenseRecordForm from './ExpenseRecordForm'
import ExpenseRecordTable from './ExpenseRecordTable'
import {
  saveExpenses,
  deleteExpenses,
  downloadPaymentVoucherFile,
  downloadEFilingFile,
  downloadWithholdingDocumentFile,
} from '../../redux/actions/accountingExpenses'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import {
  sessionGetItemJSON,
  sessionRemoveItem,
  sessionGetItemStr,
} from '../../utils/sessionHelpers'
import {
  DEFAULT_ERR_MSG,
  DELETE_SUCCESS_MSG,
  ERR_MSG,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'
import { previewFile, downloadFile } from '../../utils/fileUtil'
import ExpenseRecordView from './ExpenseRecordView'

export default function ExpenseRecordWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props?.schema?.form?.formTable?.values || [])
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)

  const [waitSendTaxSelected, setWaitSendTaxSelected] = useState([])
  const [formTableDatas, setFormTableDatas] = useState([])
  const [isChangeVatTax, setIsChangeVatTax] = useState(false)
  const [isOverActivityCost, setIsOverActivityCost] = useState(false)

  const [isSendTax, setIsSendTax] = useState(false)

  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const voucherInfo = sessionGetItemJSON('voucherInfo')
  const isViewOnly = !!sessionGetItemStr('isViewOnly')

  const fixedValue = {
    subProjectTypeCode: '2000', //เงินสนับสนุนโครงการย่อยประเภทค่าตอบแทน
    subProjectTypeCode1: '2001', //เงินสนับสนุนโครงการย่อยประเภทค่าดำเนินการ
    subProjectTypeCode2: '2002', //รับเงินคืนโครงการย่อย
    waitSendTax: '4000', //ภาษีนำส่ง
  }

  let history = useHistory()

  useEffect(() => {
    const _dataTable = dataTable?.filter((i) => !i.isSummary) || []
    if (_dataTable.length > 0) {
      let index = _dataTable.findIndex((item) => item.expensesTypeId == fixedValue.waitSendTax)
      if (index > -1) {
        setIsSendTax(true)
      } else {
        setIsSendTax(false)
      }
    } else {
      setIsSendTax(undefined)
    }
  }, [dataTable])

  const handleCallDelete = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await deleteExpenses(voucherInfo?.id)
      if (response) {
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
        })
        setIsShowConfirmDelete(false)
        sessionRemoveItem('voucherInfo')
        history.goBack()
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
      setIsShowConfirmDelete(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await saveExpenses(request, projectCode, periodInfo?.periodNumber || 0)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setRequest()
        //setIsShowConfirm(false)
        setTimeout(() => {
          if (voucherInfo?.id) {
            location.reload()
          } else {
            history.goBack()
          }
        }, 1000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
      //setIsShowConfirm(false)
    }
    setIsShowConfirm(false)
    setIsChangeVatTax(false)
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const formData = new FormData()
    var a = 1
    var file
    if (data?.attachFiles?.length > 0 && data.attachFiles != undefined) {
      // console.log('file > 0')
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
        if (a == 1) {
          file = element.blobFile
        }
        a++
      })
    } else {
      //console.log('file null')
      formData.append('AttachFiles', null)
    }

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    formData.append('Id', voucherInfo?.id || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('Period', periodInfo?.periodNumber || '')
    formData.append('RecordType', data.payTypeOptions || '')
    formData.append('VoucherNumber', data.voucherNumber || '')
    formData.append('VoucherDate', moment(data.voucherDate).format('DD/MM/YYYY') || '')
    formData.append('CheckDocNumber', data.checkDocNumber || '')
    formData.append('CheckDocDate', moment(data.checkDocDate).format('DD/MM/YYYY') || '')
    formData.append('AccountChannel', data.accountChannel || '')
    formData.append('BankInput', data.bank || '')
    formData.append('ReferenceNumber', data.referenceNumber || '')
    formData.append('Description', data.description || '')

    formData.append('IsDraft', false)
    const formTable = data.table?.filter((i) => !i.isSummary) || []
    if (formTable.length > 0) {
      let isNotSelectExpenseFor = false
      // let isOverActivityCostAmount = false

      if (formTable?.find((e) => e.isOver)) {
        setIsOverActivityCost(true)
        // notification.open('error', {
        //   title: `จำนวนเงินเกินค่าใช้จ่ายคงเหลือของกิจกรรม`,
        // })
        // return
      } else {
        setIsOverActivityCost(false)
      }

      formTable?.forEach((item, index) => {
        if (
          //item.expenseType?.typeCode != fixedValue.subProjectTypeCode &&
          item.expenseType?.typeCode != fixedValue.subProjectTypeCode1 &&
          item.expenseType?.typeCode != fixedValue.subProjectTypeCode2 &&
          item.expenseType?.typeCode != fixedValue.waitSendTax
        ) {
          if (!item.expenseFor) {
            isNotSelectExpenseFor = true
            return
          }
        }

        // if (
        //   item.expenseType?.activityCostAmount &&
        //   item.expenseTotalVat > item.expenseType?.activityCostAmount
        // ) {
        //   console.log('expenseTotalVat', item.expenseTotalVat)
        //   console.log('activityCostAmount', item.expenseType?.activityCostAmount)
        //   console.log('over activityCostAmount')
        //   isOverActivityCostAmount = true
        //   return
        // }

        if (
          item.expenseVat != item.masterExpenseVat ||
          item.expenseWithholding != item.masterExpenseWithholding
        ) {
          setIsChangeVatTax(true)
        }

        formData.set(`Detail[${index}].Id`, item.id?.indexOf('addNew') != -1 ? '' : item.id)
        formData.set(`Detail[${index}].Activity`, item.activity || '')
        formData.set(`Detail[${index}].ExpenseType`, item.expenseType?.typeCode || '')
        formData.set(`Detail[${index}].ExpenseName`, item.expenseList || '')
        formData.set(
          `Detail[${index}].SubProjectCode`,
          item.subProjectInfo || item.expenseFor?.subProjectCode || ''
        )
        formData.set(`Detail[${index}].Price`, item.expensePrice || 0)
        formData.set(`Detail[${index}].Vat`, item.expenseVat || 0)
        formData.set(`Detail[${index}].PriceIncludesVat`, item.expenseTotalVat || 0)
        formData.set(`Detail[${index}].Withholding`, item.expenseWithholding || 0)
        formData.set(
          `Detail[${index}].WithholdingType`,
          item.isWaitSendTax ? item.waitSendTaxList[0]?.taxType : item.expenseType?.taxType || ''
        )
        formData.set(`Detail[${index}].NetExpenseBalance`, item.expenseTotal || 0)
        formData.set(`Detail[${index}].ExpenseFor`, item.expenseFor?.id || '')
        formData.set(`Detail[${index}].ExpenseForName`, item.expenseFor?.name || '')
        formData.set(`Detail[${index}].ExpenseForAddress`, item.expenseFor?.address || '')

        if (item.isWaitSendTax) {
          item.waitSendTaxList?.forEach((taxItem, taxIndex) => {
            formData.set(`Detail[${index}].SendTaxIds[${taxIndex}]`, taxItem.id || '')
          })
        }

        if (isSendTax) {
          item.sendTaxValues?.forEach((taxItem, taxIndex) => {
            formData.set(`Detail[${index}].SendTaxIds[${taxIndex}]`, taxItem.id || '')
          })
        }

        if (item.dutableArticles && item.expenseType?.typeCode == '1800') {
          formData.set(
            `Detail[${index}].Asset.Count`,
            item.dutableArticles?.durableArticlesAmount || 0
          )
          formData.set(
            `Detail[${index}].Asset.Name`,
            item.dutableArticles?.durableArticlesName || ''
          )
          formData.set(
            `Detail[${index}].Asset.Price`,
            item.dutableArticles?.durableArticlesPrice || 0
          )
          formData.set(
            `Detail[${index}].Asset.Type`,
            item.dutableArticles?.durableArticlesType || 0
          )

          formData.set(
            `Detail[${index}].Asset.DocumentNo`,
            item.dutableArticles?.durableArticlesDocumentNo || ''
          )

          if (
            item.dutableArticles?.durableArticlesDocumentDate &&
            typeof item.dutableArticles?.durableArticlesDocumentDate == 'object'
          ) {
            formData.set(
              `Detail[${index}].Asset.DocumentDate`,
              moment(item.dutableArticles.durableArticlesDocumentDate).format('DD/MM/YYYY') || ''
            )
          } else if (
            item.dutableArticles?.durableArticlesDocumentDate &&
            typeof item.dutableArticles?.durableArticlesDocumentDate == 'string'
          ) {
            formData.set(
              `Detail[${index}].Asset.DocumentDate`,
              item.dutableArticles.durableArticlesDocumentDate
            )
          }

          if (
            item.dutableArticles?.durableArticlesAttachFiles &&
            typeof item.dutableArticles?.durableArticlesAttachFiles == 'object'
          ) {
            formData.set(
              `Detail[${index}].Asset.AttachFiles`,
              item.dutableArticles?.durableArticlesAttachFiles[0]?.blobFile || ''
            )
          } else if (
            item.dutableArticles?.durableArticlesAttachFiles &&
            typeof item.dutableArticles?.durableArticlesAttachFiles == 'string'
          ) {
            formData.set(
              `Detail[${index}].Asset.AttachFilesPath`,
              item.dutableArticles?.durableArticlesAttachFiles || ''
            )
          } else if (
            !item.dutableArticles?.durableArticlesAttachFiles ||
            typeof item.dutableArticles?.durableArticlesAttachFiles == 'undefined'
          ) {
            formData.set(`Detail[${index}].Asset.AttachFiles`, '')
          }

          if (
            item.dutableArticles?.durableArticlesDocumentAttachFiles &&
            typeof item.dutableArticles?.durableArticlesDocumentAttachFiles == 'object'
          ) {
            formData.set(
              `Detail[${index}].Asset.DocumentAttachFiles`,
              item.dutableArticles?.durableArticlesDocumentAttachFiles[0]?.blobFile || ''
            )
          } else if (
            item.dutableArticles?.durableArticlesDocumentAttachFiles &&
            typeof item.dutableArticles?.durableArticlesDocumentAttachFiles == 'string'
          ) {
            formData.set(
              `Detail[${index}].Asset.DocumentAttachFilesPath`,
              item.dutableArticles?.durableArticlesDocumentAttachFiles || ''
            )
          } else if (
            !item.dutableArticles?.durableArticlesDocumentAttachFiles ||
            typeof item.dutableArticles?.durableArticlesDocumentAttachFiles == 'undefined'
          ) {
            formData.set(`Detail[${index}].Asset.DocumentAttachFiles`, '')
          }
        }
      })

      if (isNotSelectExpenseFor) {
        notification.open('error', {
          title: 'กรุณาเลือกผู้รับเงิน',
        })
        return
      }

      // if (isOverActivityCostAmount) {
      //   notification.open('error', {
      //     title: `จำนวนเงินเกินค่าใช้จ่ายกิจกรรม`,
      //   })
      //   return
      // }
    } else {
      notification.open('error', {
        title: 'กรุณาเพิ่มรายการบันทึกจ่าย อย่างน้อย 1 รายการ',
      })
      return
    }

    setRequest(formData)

    setIsShowConfirm(true)
  }
  const DraftOnSumit = () => {
    const data = getValues()

    console.log('draft data', data)

    const formData = new FormData()

    if (Array.isArray(data.attachFiles) && data.attachFiles.length > 0) {
      data.attachFiles.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })
    }

    if (Array.isArray(data.deleteFileIds)) {
      data.deleteFileIds.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })
    }

    formData.append('Id', voucherInfo?.id || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('Period', periodInfo?.periodNumber || '')
    formData.append('RecordType', data.payTypeOptions || '')
    formData.append('VoucherNumber', data.voucherNumber || '')

    formData.append(
      'VoucherDate',
      data.voucherDate ? moment(data.voucherDate).format('DD/MM/YYYY') : ''
    )

    formData.append('CheckDocNumber', data.checkDocNumber || '')

    formData.append(
      'CheckDocDate',
      data.checkDocDate ? moment(data.checkDocDate).format('DD/MM/YYYY') : ''
    )

    formData.append('AccountChannel', data.accountChannel || '')
    formData.append('BankInput', data.bank || '')
    formData.append('ReferenceNumber', data.referenceNumber || '')
    formData.append('Description', data.description || '')

    formData.append('IsDraft', true)

    const formTable = data.table?.filter((i) => !i.isSummary) || []

    if (formTable.length > 0) {
      formTable.forEach((item, index) => {
        formData.set(`Detail[${index}].Id`, item.id?.indexOf('addNew') !== -1 ? '' : item.id || '')
        formData.set(`Detail[${index}].Activity`, item.activity || '')
        formData.set(`Detail[${index}].ExpenseType`, item.expenseType?.typeCode || '')
        formData.set(`Detail[${index}].ExpenseName`, item.expenseList || '')

        formData.set(
          `Detail[${index}].SubProjectCode`,
          item.subProjectInfo || item.expenseFor?.subProjectCode || ''
        )

        formData.set(`Detail[${index}].Price`, item.expensePrice || 0)
        formData.set(`Detail[${index}].Vat`, item.expenseVat || 0)
        formData.set(`Detail[${index}].PriceIncludesVat`, item.expenseTotalVat || 0)
        formData.set(`Detail[${index}].Withholding`, item.expenseWithholding || 0)

        formData.set(
          `Detail[${index}].WithholdingType`,
          item.isWaitSendTax
            ? item.waitSendTaxList?.[0]?.taxType || ''
            : item.expenseType?.taxType || ''
        )

        formData.set(`Detail[${index}].NetExpenseBalance`, item.expenseTotal || 0)
        formData.set(`Detail[${index}].ExpenseFor`, item.expenseFor?.id || '')
        formData.set(`Detail[${index}].ExpenseForName`, item.expenseFor?.name || '')
        formData.set(`Detail[${index}].ExpenseForAddress`, item.expenseFor?.address || '')

        if (item.isWaitSendTax) {
          item.waitSendTaxList?.forEach((taxItem, taxIndex) => {
            formData.set(`Detail[${index}].SendTaxIds[${taxIndex}]`, taxItem.id || '')
          })
        }

        if (isSendTax) {
          item.sendTaxValues?.forEach((taxItem, taxIndex) => {
            formData.set(`Detail[${index}].SendTaxIds[${taxIndex}]`, taxItem.id || '')
          })
        }

        if (item.dutableArticles && item.expenseType?.typeCode === '1800') {
          formData.set(
            `Detail[${index}].Asset.Count`,
            item.dutableArticles?.durableArticlesAmount || 0
          )

          formData.set(
            `Detail[${index}].Asset.Name`,
            item.dutableArticles?.durableArticlesName || ''
          )

          formData.set(
            `Detail[${index}].Asset.Price`,
            item.dutableArticles?.durableArticlesPrice || 0
          )

          formData.set(
            `Detail[${index}].Asset.Type`,
            item.dutableArticles?.durableArticlesType || 0
          )

          formData.set(
            `Detail[${index}].Asset.DocumentNo`,
            item.dutableArticles?.durableArticlesDocumentNo || ''
          )

          if (
            item.dutableArticles?.durableArticlesDocumentDate &&
            typeof item.dutableArticles?.durableArticlesDocumentDate === 'object'
          ) {
            formData.set(
              `Detail[${index}].Asset.DocumentDate`,
              moment(item.dutableArticles.durableArticlesDocumentDate).format('DD/MM/YYYY') || ''
            )
          } else if (
            item.dutableArticles?.durableArticlesDocumentDate &&
            typeof item.dutableArticles?.durableArticlesDocumentDate === 'string'
          ) {
            formData.set(
              `Detail[${index}].Asset.DocumentDate`,
              item.dutableArticles.durableArticlesDocumentDate
            )
          }

          if (
            item.dutableArticles?.durableArticlesAttachFiles &&
            typeof item.dutableArticles?.durableArticlesAttachFiles === 'object'
          ) {
            formData.set(
              `Detail[${index}].Asset.AttachFiles`,
              item.dutableArticles?.durableArticlesAttachFiles[0]?.blobFile || ''
            )
          } else if (
            item.dutableArticles?.durableArticlesAttachFiles &&
            typeof item.dutableArticles?.durableArticlesAttachFiles === 'string'
          ) {
            formData.set(
              `Detail[${index}].Asset.AttachFilesPath`,
              item.dutableArticles?.durableArticlesAttachFiles || ''
            )
          }

          if (
            item.dutableArticles?.durableArticlesDocumentAttachFiles &&
            typeof item.dutableArticles?.durableArticlesDocumentAttachFiles === 'object'
          ) {
            formData.set(
              `Detail[${index}].Asset.DocumentAttachFiles`,
              item.dutableArticles?.durableArticlesDocumentAttachFiles[0]?.blobFile || ''
            )
          } else if (
            item.dutableArticles?.durableArticlesDocumentAttachFiles &&
            typeof item.dutableArticles?.durableArticlesDocumentAttachFiles === 'string'
          ) {
            formData.set(
              `Detail[${index}].Asset.DocumentAttachFilesPath`,
              item.dutableArticles?.durableArticlesDocumentAttachFiles || ''
            )
          }
        }
      })
    }

    setRequest(formData)
    setIsShowConfirm(true)
  }
  const onPreview = async (filePath) => {
    startLoading()
    try {
      var files = filePath?.split('/')
      var file = await downloadPaymentVoucherFile(filePath)

      previewFile(file, files[files.length - 1])
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownloadWithholdingDocument = async (filePath) => {
    startLoading()
    try {
      var files = filePath?.split('/')
      var file = await downloadWithholdingDocumentFile(filePath)

      downloadFile(file, files[files.length - 1])
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownloadEFiling = async (filePath) => {
    startLoading()
    try {
      var files = filePath?.split('/')
      var file = await downloadEFilingFile(filePath)

      downloadFile(file, files[files.length - 1])
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {!isViewOnly && !formSchema?.disabled ? (
          <>
            <ExpenseRecordForm
              schema={formSchema?.form}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              formTableDatas={formTableDatas}
              onSelectWaitSendTax={(rowDataSelected) => setWaitSendTaxSelected(rowDataSelected)}
              isSendTax={isSendTax}
            />
          </>
        ) : (
          <>
            <ExpenseRecordView
              schema={formSchema?.form}
              formTableDatas={formTableDatas}
              onSelectWaitSendTax={(rowDataSelected) => setWaitSendTaxSelected(rowDataSelected)}
            />
          </>
        )}

        <ExpenseRecordTable
          schema={formSchema?.form?.formTable}
          //schema={mockFormTable}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setError={setError}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          waitSendTaxSelected={waitSendTaxSelected}
          onAddNewData={(datas) => setFormTableDatas(datas)}
          isViewMode={isViewOnly || formSchema?.disabled}
          isSendTax={isSendTax}
          isAddDisabled={formSchema?.form?.isAddDisabled}
        />

        <div>
          <br />
          <Row>
            {isError && (
              <Message showIcon type="error" description={isError} style={{ marginBottom: 10 }} />
            )}
            <Col lg={4} md={4} sm={24} xs={24}>
              {!isViewOnly && !formSchema?.disabled && (
                <Button
                  color="red"
                  appearance="link"
                  onClick={() => setIsShowConfirmDelete(true)}
                  disabled={!voucherInfo?.id || isLoading || formSchema?.form?.isDeleteDisabled}
                >
                  <Icon icon="trash" size="lg" /> ลบเอกสาร
                </Button>
              )}
            </Col>
            <Col lg={20} md={20} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <Button
                color="blue"
                appearance="link"
                disabled={formSchema?.form?.enableSaveDraft || !formSchema?.form?.efilingPath}
                onClick={() => {
                  onDownloadEFiling(formSchema?.form?.efilingPath)
                }}
              >
                <Icon icon="eye" size="lg" /> โหลด e-Filing
              </Button>
              <Button
                color="blue"
                appearance="link"
                disabled={
                  formSchema?.form?.enableSaveDraft || !formSchema?.form?.withholdingDocumentPath
                }
                onClick={() => {
                  onDownloadWithholdingDocument(formSchema?.form?.withholdingDocumentPath)
                }}
              >
                <Icon icon="eye" size="lg" /> ใบปะหน้านำส่งภาษี
              </Button>
              <Button
                color="blue"
                appearance="link"
                disabled={formSchema?.form?.enableSaveDraft || !voucherInfo?.id}
                onClick={() => {
                  onPreview(voucherInfo?.id)
                }}
              >
                <Icon icon="eye" size="lg" /> ใบสำคัญจ่าย
              </Button>
              {!isViewOnly && !formSchema?.disabled && (
                <>
                  {formSchema?.form?.enableSaveDraft && (
                    <SaveButton
                      onClick={DraftOnSumit}
                      disabled={isLoading || formSchema?.form?.isEditDisabled}
                    >
                      บันทึกร่าง
                    </SaveButton>
                  )}

                  <SaveButton
                    onClick={handleSubmit(onSubmit)}
                    disabled={isLoading || formSchema?.form?.isEditDisabled}
                  >
                    บันทึก
                  </SaveButton>
                  <CancelButton
                    onClick={() => {
                      history.goBack()
                    }}
                    disabled={isLoading}
                  >
                    ยกเลิก
                  </CancelButton>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Panel>

      <ConfirmWidget
        title={'ยืนยันการบันทึก'}
        show={isShowConfirm}
        detail={
          <>
            {isChangeVatTax && (
              <Message
                showIcon
                type="warning"
                description={'แจ้งเตือน : มีการเปลี่ยนแปลงภาษีมูลค่าเพิ่มหรือภาษีหัก ณ ที่จ่าย'}
              />
            )}
            {isOverActivityCost && (
              <Message
                showIcon
                type="warning"
                description={'แจ้งเตือน : จำนวนเงินเกินค่าใช้จ่ายคงเหลือของกิจกรรม'}
              />
            )}
          </>
        }
        onCancle={() => {
          setIsShowConfirm(false)
          setIsChangeVatTax(false)
        }}
        onConfirm={handleCallService}
        size={'sm'}
      />

      <ConfirmWidget
        title={'ยืนยันลบเอกสาร'}
        show={isShowConfirmDelete}
        //detail={'ยืนยันลบเอกสาร'}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleCallDelete}
      />
    </>
  )
}
